import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d21bba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkoutsuccess" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex mb-4" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "center display-2 headline" }, "Tak for dit køb")
  ])
], -1))
const _hoisted_3 = { class: "row justify--center" }
const _hoisted_4 = { class: "flex mt-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tilbage til forside")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_button, {
          class: "center",
          color: "success",
          gradient: "",
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}